import { GetCollectionRecordsQuery } from '@indigohive/cogfy-types/endpoints/getCollectionRecords'
import { useCogfy } from './use-cogfy'
import { useQuery } from '@tanstack/react-query'
import { UUID } from '@indigohive/cogfy-types'

export function useCollectionRecords (
  query: Omit<GetCollectionRecordsQuery, 'collectionId'> & { collectionId?: UUID }
) {
  const cogfy = useCogfy()

  const getCollectionRecords = useQuery({
    queryKey: ['getCollectionRecords', { query }] as const,
    queryFn: ({ queryKey, signal }) => cogfy.getCollectionRecords({ collectionId: queryKey[1].query.collectionId!, ...queryKey[1].query }, { signal }),
    placeholderData: prev => prev
  })

  return getCollectionRecords
}
